<template>
  <div
    class="w-full md:py-0 py-2"
    :class="iconRight ? 'justify-end' : 'justify-start '"
  >
    <div
      class="flex items-center"
      :class="iconRight ? 'flex-row inputIconRight' : 'flex-row-reverse'"
    >
      <slot name="icon"></slot>

      <slot name="input"> </slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    iconRight: {
      type: Boolean,
      default: true,
    },
  },
};
</script>